import {
  CrewShiftsData,
  ShiftsResponse as Response,
  Uri,
  convertCrewShifts,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useCrewShifts(uri: Uri) {
  const { server } = useServer()
  return useQuery<CrewShiftsData>({
    queryKey: keys.crew(uri),
    queryFn: fetchCrewShifts,
  })

  async function fetchCrewShifts() {
    return convertCrewShifts(await server.get<Response.CrewShifts>(uri))
  }
}
